<template>
  <ul class="sr_process">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: "SrProcess",

  components: {},

  data() {
    return {};
  },

  mounted() {
    this.onLoad();
  },

  methods: {
    onLoad() {}
  }
};
</script>
<style lang="scss" scoped>
.sr_process {
}
</style>



// WEBPACK FOOTER //
// packages/SrProcess/index.vue